'use es6';

import { useCallback, useEffect, useMemo, useState, useContext, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import FiltersPanel from './FiltersPanel';
import StorefrontUsageTrackerContext from '../../../context/StorefrontUsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const subscreen = 'mobile filter panel';
const PanelKeys = {
  FILTERS: 'FILTERS',
  DRILLDOWN: 'DRILLDOWN'
};
const FilterPanelNavigator = ({
  filters,
  onClearFilters,
  onSetFilter,
  onDeleteFilter
}) => {
  const [currentPanel, setCurrentPanel] = useState(null);
  const [panelOpen, setPanelOpen] = useState(false);
  const location = useLocation();
  const {
    focusMobileFilterButton,
    mobileFilterButtonRef,
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  useEffect(() => {
    if (currentPanel) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [currentPanel]);
  const onClosePanel = useCallback(() => {
    setCurrentPanel(null);
    focusMobileFilterButton();
  }, [focusMobileFilterButton]);
  useEffect(() => {
    onClosePanel();
  }, [onClosePanel, location]);
  const setFilter = useCallback(filtersObject => {
    onSetFilter(filtersObject);
    Object.keys(filtersObject).forEach(filterKey => {
      trackInteraction('change filter', {
        filter: filterKey,
        value: filtersObject[filterKey],
        subscreen
      });
    });
  }, [onSetFilter, trackInteraction]);
  const renderedPanel = useMemo(() => {
    return /*#__PURE__*/_jsx(FiltersPanel, {
      onClearFilters: () => {
        trackInteraction('clear all filters', {
          subscreen
        });
        onClearFilters();
      },
      onDeleteFilter: filterKey => {
        trackInteraction('clear filter', {
          filter: filterKey,
          subscreen
        });
        onDeleteFilter(filterKey);
      },
      open: panelOpen,
      onSelectedFilterChange: filterKey => {
        trackInteraction('open filters panel', {
          subscreen,
          filterKey
        });
      },
      onPanelClose: () => {
        trackInteraction('close filters panel', {
          subscreen
        });
        onClosePanel();
        setPanelOpen(false);
      },
      onSetFilter: setFilter,
      filters: filters
    });
  }, [filters, onClearFilters, onClosePanel, onDeleteFilter, panelOpen, setFilter, trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => {
        setPanelOpen(true);
        setCurrentPanel(PanelKeys.FILTERS);
        trackInteraction('open filters panel');
      },
      size: "sm",
      use: "tertiary-light",
      tabIndex: -1,
      inlineSize: "auto",
      marginInlineStart: "500",
      children: /*#__PURE__*/_jsx("div", {
        ref: mobileFilterButtonRef,
        role: "button",
        tabIndex: 0,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.storefront.filters.filter"
        })
      })
    }), renderedPanel]
  });
};
export default FilterPanelNavigator;